import React from 'react';
import { AdminPageShell } from '../_components/AdminPageShell';
import { OrgEntitlementsPanel } from '@/components/admin/OrgEntitlementsPanel';

export const AdminEntitlementsPage: React.FC = () => (
  <AdminPageShell title="Entitlements">
    <OrgEntitlementsPanel />
  </AdminPageShell>
);
